export default "__VITE_ASSET__WhG4x0Og__"